import { createAction } from 'redux-actions';

export const createUpdateShowingAction = createAction('REQUEST/CREATE_UPDATE_SHOWING');
export const deleteShowingAction = createAction('DELETE/DELETE_SHOWING');
export const sendAnnouncementAction = createAction('POST/MEGA_PHONE_ANNOUNCEMENT');
